import React from 'react';
import MonacoEditor from '@monaco-editor/react';

function CodeEditor({ value, onChange, language, onLanguageChange }) {
  const editorOptions = {
    minimap: { enabled: true }, // Enable minimap
    automaticLayout: true, // Automatically adjust the editor layout
    contextmenu: true, // Enable context menu
    cursorBlinking: 'smooth', // Set cursor blinking style
    dragAndDrop: true, // Enable drag and drop editing
    fontFamily: 'Fira Code', // Set font family
    fontLigatures: true, // Enable font ligatures
    fontSize: 14, // Set font size
    lineDecorationsWidth: 1, // Set width of line decorations
    lineNumbers: 'on', // Enable line numbers
    lineNumbersMinChars: 3, // Set minimum number of characters to render for each line number
    mouseWheelZoom: true, // Enable mouse wheel zoom
    renderIndentGuides: true, // Render vertical lines at each indentation level
    renderLineHighlight: 'all', // Set style for the currently active line highlight
    scrollbar: { // Configure the scrollbar
      vertical: 'visible', // Always show vertical scrollbar
      horizontal: 'visible', // Always show horizontal scrollbar
      arrowSize: 6, // Set arrow size
      useShadows: true, // Enable shadows
      verticalScrollbarSize: 10, // Set vertical scrollbar size
      horizontalScrollbarSize: 10, // Set horizontal scrollbar size
    },
    scrollBeyondLastLine: true, // Enable scrolling beyond the last line
    smoothScrolling: true, // Enable smooth scrolling
    suggest: { showIcons: true }, // Show icons in suggestions
    wordWrap: 'on', // Enable word wrap
    wrappingIndent: 'indent', // Set wrapping indentation mode
  };

  return (

    <MonacoEditor
    className='min-h-[50vh] w-auto h-full  border overflow-hidden '
      height="100%"
      language={language}
      theme="vs-dark"
      value={value}
      options={editorOptions}
      onChange={onChange}
      />
  );
}

export default CodeEditor;
